import AssessmentPaper from '@/apps/assessment/components/assessment-paper'
import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import { getProgress } from '@/apps/assessment/model/api'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
const columns = [
  {
    title: '班级',
    dataIndex: 'dimensionName',
    width: '',
    scopedSlots: { customRender: 'dimensionName' }
  },
  {
    title: '班级学生人数',
    dataIndex: 'num',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '班级已参与学生数',
    dataIndex: 'planNum',
    scopedSlots: { customRender: 'planNum' }
  },
  {
    title: '班级参与率',
    dataIndex: 'rate',
    width: '',
    scopedSlots: { customRender: 'rate' }
  }
]
@Component({
  components: { AssessmentPaper, BasicLayout }
})
export default class ClazzAssessmentInfo extends Mixins(RouterMixin) {
  private dataSource = []
  private columns = columns
  private dimensionName = ''
  private get record() {
    return this.$route.query.record
      ? JSON.parse(decodeURIComponent(String(this.$route.query.record)))
      : ''
  }
  public mounted() {
    this.getProgress()
  }
  public back() {
    this.$router.back()
  }
  public publish() {
    this.$router.push({
      path: '/assessment/publish'
    })
  }

  public async getProgress() {
    const data: any = await getProgress({
      examId: this.record.examId,
      dimensionIds: this.record.dimensionIds,
      dimensionType: 4
    })
    if (data.success) {
      if (data && data.data && data.data.length > 0) {
        this.dataSource = data.data[0].childData
        this.dimensionName = data.data[0].dimensionName
        console.log(this.dimensionName)
      }
    } else {
      this.dataSource = []
      this.dimensionName = ''
    }
  }
}
